import React from 'react';
import {List, Datagrid, TextField, ReferenceField} from 'react-admin';
import {Filter, ReferenceInput, TextInput, SelectInput} from 'react-admin';
import { Fragment } from 'react';
import ButtonCreateJob from './ButtonCreateJob';

const HydrantFilter = () => (
  <Filter>
    <TextInput label="Device Id" source="deviceId" alwaysOn />
    <ReferenceInput label="Firmware" source="firmwareId" reference="firmwares" allowEmpty>
        <SelectInput optionText="version" />
    </ReferenceInput>
  </Filter>
);

const PostBulkActionButtons = () => (
  <Fragment>
      <ButtonCreateJob/>
  </Fragment>
);

export const HydrantList = () => {
  return (
    <>
      <List title='Hydrant Fleet Management - Hydrants' 
        exporter={false}
        bulkActionButtons={<PostBulkActionButtons />} 
        filters={<HydrantFilter />}
        perPage={50}
      >
        <Datagrid>
          <TextField label="Device Id" source="id" />
          <ReferenceField label='Firmware' source='firmwareId' reference='firmwares'>
            <TextField source="version" />
          </ReferenceField>
          <TextField label="Device Tag"source="deviceTag" />
          <TextField label="Device Type" source="deviceType" />
          <TextField label="Status" source="status" />
          <TextField label="Longitude" source="longitude" />
          <TextField label="Latitude" source="latitude" />
        </Datagrid>
      </List>
    </>  
  );
};

  
  